(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zahra-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const readyClass = 'zahra-motion-ready';
    const targetClass = 'zahra-motion';
    const visibleClass = 'is-visible';
    const imageSelector = 'image-banner img, picture img, .product-card img, [class*="image"] img';
    const textSelector = '.prose > *, .section-header > *, .section__header > *, h1, h2, h3, .button, a[class*="button"]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observedSections = new WeakSet();

    document.documentElement.classList.add(readyClass);

    const reveal = (section) => {
      section.querySelectorAll('.' + targetClass).forEach((element) => {
        element.classList.add(visibleClass);
      });
    };

    const isInInitialViewport = (section) => {
      const rect = section.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
    };

    const observer = reducedMotion.matches
      ? null
      : new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              reveal(entry.target);
              observer.unobserve(entry.target);
            });
          },
          {
            rootMargin: '0px 0px -8% 0px',
            threshold: 0.12
          }
        );

    const prepareSection = (section) => {
      if (observedSections.has(section)) return;
      if (section.closest('[id*="footer"]')) return;

      observedSections.add(section);

      const imageTargets = Array.from(section.querySelectorAll(imageSelector)).slice(0, 8);
      const textTargets = Array.from(section.querySelectorAll(textSelector))
        .filter((element) => !element.closest('header, footer'))
        .slice(0, 10);

      imageTargets.forEach((element, index) => {
        element.classList.add(targetClass, 'zahra-motion--image');
        element.style.setProperty('--zahra-motion-delay', String(50 + index * 70) + 'ms');
      });

      textTargets.forEach((element, index) => {
        element.classList.add(targetClass, 'zahra-motion--text');
        element.style.setProperty('--zahra-motion-delay', String(120 + index * 85) + 'ms');
      });

      if (reducedMotion.matches || isInInitialViewport(section) || !observer) {
        reveal(section);
        return;
      }

      observer.observe(section);
    };

    const initialize = (root = document) => {
      if (root.matches && root.matches('.shopify-section')) prepareSection(root);
      root.querySelectorAll('#main .shopify-section, .shopify-section[id*="template"]').forEach(prepareSection);
    };

    initialize();

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:select', (event) => reveal(event.target));
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) {
        document.querySelectorAll('.' + targetClass).forEach((element) => {
          element.classList.add(visibleClass);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
